export default "__VITE_ASSET__B2UhFN7I__"